<script>
export default {
	name: 'AquaSelect',
	model: {
		prop: 'value',
		event: 'change',
	},
	props: {
		value: {
			type: [String, Number, Boolean],
			default: null,
		},
		options: {
			type: Array,
			default: () => [],
		},
		label: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		selected: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('change', value)
			},
		},
	},
}
</script>

<template>
	<label class="aqua-select" :class="{ 'aqua-select--labeled': label }">
		<span v-if="label" class="aqua-select__label">{{ label }}</span>
		<select v-model="selected" class="aqua-select__control" :disabled="disabled">
			<option v-for="option in options" :key="String(option.value)" :value="option.value">{{ option.text }}</option>
		</select>
	</label>
</template>

<style scoped>
.aqua-select {
	display: inline-flex;
	flex-direction: column;
	gap: 4px;
	min-width: 140px;
	margin: 0;
}
.aqua-select__label {
	font-size: 13px;
	color: #475f84;
}
.aqua-select__control {
	width: 100%;
	height: 41px;
	padding: 0 38px 0 14px;
	border: 1px solid #157fee;
	border-radius: 5px;
	background: #fff
		url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0h10L5 6z' fill='%230a091d'/%3E%3C/svg%3E")
		no-repeat right 14px center;
	appearance: none;
	color: #0a091d;
	font-size: 15px;
	cursor: pointer;
}
.aqua-select__control:focus {
	outline: none;
	box-shadow: 0 0 0 3px rgba(21, 127, 238, 0.15);
}
.aqua-select__control[disabled] {
	border-color: #d3e7fb;
	cursor: default;
}
</style>
